import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import NoDataAlert from '../utils/NoDataAlert'
import { useLocation } from 'react-router-dom'
import { boolean } from 'yup'

const MembershipSaleTable = ({ membershipRecords }) => {
    const { pathname } = useLocation()
    const [ isStaffDetail,setIsStaffDetail ] = useState(false)
    useEffect(()=>{
        if(pathname.includes('staff-detail')){
            setIsStaffDetail(true)
        }else{
            setIsStaffDetail(false)
        }
    },[pathname])
  return (
    <div style={{ pageBreakAfter: "always" }}>
        <Typography sx={{ pl: 2, fontWeight: 'bold' }}>Membership Sale Records</Typography>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontSize: '12px' }} align="center">No</TableCell>
                            {
                                isStaffDetail === false && <TableCell sx={{ fontSize: '12px' }}>Customer Name</TableCell>
                            }
                            <TableCell sx={{ fontSize: '12px' }}>Service Name</TableCell>
                            {
                                isStaffDetail === false && 
                                <>
                                    <TableCell sx={{ fontSize: '12px' }}>Staffs</TableCell>
                                    <TableCell sx={{ fontSize: '12px' }}>Service Price</TableCell>
                                    <TableCell sx={{ fontSize: '12px' }} align='center'>Qty</TableCell>
                                </>
                            }
                            <TableCell sx={{ fontSize: '12px' }} align='center'>{
                                isStaffDetail === true ? "Commission" : "Commission (%)"
                            }</TableCell>
                            <TableCell sx={{ fontSize: '12px' }} align="right">Price</TableCell>                      
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            membershipRecords && membershipRecords.length > 0 ?
                            membershipRecords.map((rec,index)=>
                            <TableRow key={index}>
                                <TableCell sx={{ fontSize: '12px' }} align="center">{index+ 1}</TableCell>
                                {
                                    isStaffDetail === false && <TableCell sx={{ fontSize: '12px' }}>{rec.customerName}</TableCell>
                                }
                                <TableCell sx={{ fontSize: '12px' }}>{rec.serviceName}</TableCell>
                                {
                                    isStaffDetail === false &&
                                    <>
                                        <TableCell sx={{ fontSize: '12px' }}>{rec.employees && rec.employees.length > 0 && rec.employees.map(el=> `${el.name}${el.status ? ` (${el.status}- ${el.commission} MMK)` : ` (${el.commission} MMK)`}, ` )}</TableCell>
                                        <TableCell sx={{ fontSize: '12px' }}>{rec.servicePrice}</TableCell>
                                        <TableCell sx={{ fontSize: '12px' }} align='center'>{Number(rec.time) + Number(rec.freeTime)}</TableCell>
                                    </>
                                }
                                <TableCell sx={{ fontSize: '12px' }} align='center'>
                                    {
                                        isStaffDetail === false ?
                                        `${rec.commissionPercent !== null ? `${rec.commissionPercent} %` : `0 %` }`
                                        :
                                        `${rec.commission !== null ? `${rec.commission} MMK` : "0 MMK"}`
                                    }                               </TableCell>
                                <TableCell sx={{ fontSize: '12px' }} align="right">{rec.price}</TableCell>     
                            </TableRow>
                            )                            
                            :
                            <TableRow>
                                <TableCell sx={{ fontSize: '12px' }} colSpan={8}>
                                    <NoDataAlert content={"There is no records"}></NoDataAlert>
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
    </div>
  )
}

export default MembershipSaleTable
